"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _constructedForm = _interopRequireDefault(require("../styles/constructed-form.css"));
var _constructedForm2 = _interopRequireDefault(require("./constructed-form.props/constructed-form.defaultProps"));
var _constructedForm3 = _interopRequireDefault(require("./constructed-form.props/constructed-form.propTypes"));
var _p;
/**
 * ## CalendarPanel - component
 *
 * Some really cool piece of description goes here.
 */
// We use the same default props for data and defaultData
// This keeps our PropTypes and DefaultProps objects nice and clean and non repeating
// eslint-disable-next-line
var getDaysInMonth = function getDaysInMonth(month, year) {
  var currentYear = Number(year);
  var returnValue = 0;
  var oddDays = [0, 2, 4, 6, 7, 9, 11]; //eslint-disable-line

  if (oddDays.indexOf(month) > -1) {
    returnValue = 31; // eslint-disable-line
    // eslint-disable-next-line
  } else if (month === 3 || month === 5 || month === 8 || month === 10) {
    returnValue = 30; // eslint-disable-line
  } else if (month === 1) {
    // eslint-disable-next-line
    if (currentYear % 4 === 0 && currentYear % 100 !== 0 || currentYear % 4 === 0 && currentYear % 100 === 0 && currentYear % 400 === 0) {
      returnValue = 29; // eslint-disable-line
    } else {
      returnValue = 28; // eslint-disable-line
    }
  }
  return returnValue;
};
var getDateArray = function getDateArray(month, year) {
  var arr = [];
  var dt = new Date();
  var endDate = new Date();
  dt.setFullYear(year);
  dt.setMonth(month);
  dt.setDate(1);
  endDate.setFullYear(year);
  endDate.setMonth(month);
  endDate.setDate(getDaysInMonth(month, year));
  while (dt <= endDate) {
    arr.push(new Date(dt));
    dt.setDate(dt.getDate() + 1);
  }
  return arr;
};
var getShiftedDay = function getShiftedDay(date, weekStartDay) {
  var adjustedDayIndex = date.getUTCDay();
  if (weekStartDay > 0) {
    adjustedDayIndex = adjustedDayIndex - weekStartDay >= 0 ? adjustedDayIndex - weekStartDay : 7 + (adjustedDayIndex - weekStartDay); // eslint-disable-line
  }
  return adjustedDayIndex;
};
var CalendarPanel = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(CalendarPanel, _React$Component);
  // All components need a resourceType in order for AEM to be aware of its existance
  CalendarPanel.resourceType = function resourceType() {
    return 'TextField_1_0_0';
  };
  CalendarPanel.getDerivedStateFromProps = function getDerivedStateFromProps(props) {
    var _props$data = props.data,
      dayNames = _props$data.dayNames,
      weekStartDay = _props$data.weekStartDay,
      month = _props$data.month,
      year = _props$data.year;
    var dayMap = dayNames.map(function (dayName, i) {
      var updatedDayName = dayNames[i + weekStartDay];
      if (updatedDayName === undefined) {
        updatedDayName = dayNames[i + (weekStartDay - 7)]; // eslint-disable-line
      }
      return updatedDayName;
    });
    var calendarArray = getDateArray(month, year);
    var calendarStartDay = getShiftedDay(calendarArray[0], weekStartDay);
    var calendarEndDay = getShiftedDay(calendarArray[calendarArray.length - 1], weekStartDay);
    for (var i = 0; i < calendarStartDay; i++) {
      calendarArray.unshift(null);
    }
    // eslint-disable-next-line
    for (var j = 0; j < 6 - calendarEndDay; j++) {
      calendarArray.push(null);
    }
    return {
      dayMap: dayMap,
      calendarArray: calendarArray
    };
  };
  function CalendarPanel(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    var _props$data2 = props.data,
      dayNames = _props$data2.dayNames,
      weekStartDay = _props$data2.weekStartDay,
      month = _props$data2.month,
      year = _props$data2.year;
    var dayMap = dayNames.map(function (dayName, i) {
      var updatedDayName = dayNames[i + weekStartDay];
      if (updatedDayName === undefined) {
        updatedDayName = dayNames[i + (weekStartDay - 7)]; // eslint-disable-line
      }
      return updatedDayName;
    });
    var calendarArray = getDateArray(month, year);
    var calendarStartDay = getShiftedDay(calendarArray[0], weekStartDay);
    var calendarEndDay = getShiftedDay(calendarArray[calendarArray.length - 1], weekStartDay);
    for (var i = 0; i < calendarStartDay; i++) {
      calendarArray.unshift(null);
    }
    // eslint-disable-next-line
    for (var j = 0; j < 6 - calendarEndDay; j++) {
      calendarArray.push(null);
    }
    var clickDateButtonHandler = _this.props.clickDateButtonHandler || _this.clickDateButtonHandler.bind((0, _assertThisInitialized2["default"])(_this));
    var focusDateButtonHandler = _this.props.focusDateButtonHandler || _this.focusDateButtonHandler.bind((0, _assertThisInitialized2["default"])(_this));
    _this.state = {
      dayMap: dayMap,
      calendarArray: calendarArray,
      clickDateButtonHandler: clickDateButtonHandler,
      focusDateButtonHandler: focusDateButtonHandler,
      today: _this.setToday()
    };
    _this.isInPast = _this.isInPast.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = CalendarPanel.prototype;
  _proto.setToday = function setToday() {
    var today = new Date();
    return today.setHours(0, 0, 0, 0);
  };
  _proto.clickDateButtonHandler = function clickDateButtonHandler(e) {
    e.preventDefault();
    // console.log("local click");
  };
  _proto.focusDateButtonHandler = function focusDateButtonHandler(e) {
    e.preventDefault();
    // console.log("local focus");
  };
  _proto.isInPast = function isInPast(today, secondDate) {
    return secondDate < today;
  };
  _proto.renderCalendarPanel = function renderCalendarPanel() {
    var _this2 = this;
    // const { month, year, dayNames, weekStartDay, activeDate, browseDate } = this.props.data;
    var _this$props$data = this.props.data,
      activeDate = _this$props$data.activeDate,
      browseDate = _this$props$data.browseDate;
    var _this$state = this.state,
      dayMap = _this$state.dayMap,
      calendarArray = _this$state.calendarArray,
      clickDateButtonHandler = _this$state.clickDateButtonHandler,
      focusDateButtonHandler = _this$state.focusDateButtonHandler,
      today = _this$state.today;
    // const calendarDates = getDateArray(month, year);
    var theme = this.props.theme || {};
    var weekCount = 0;
    var calendarWeeks = [];
    for (var i = 0; i < calendarArray.length; i++) {
      // eslint-disable-next-line
      if (i > 0 && i % 7 === 0) {
        weekCount++;
      }
      if (calendarWeeks[weekCount] === undefined) {
        calendarWeeks[weekCount] = [];
      }
      calendarWeeks[weekCount].push(calendarArray[i]);
    }
    return /*#__PURE__*/_react["default"].createElement("table", {
      className: _constructedForm["default"].calendar
    }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, dayMap.map(function (adjustedDayName, i) {
      return /*#__PURE__*/_react["default"].createElement("th", {
        className: _constructedForm["default"].dateHeader + " " + theme.BodyCopyBold,
        key: i
      }, adjustedDayName);
    }))), /*#__PURE__*/_react["default"].createElement("tbody", null, calendarWeeks.map(function (weekArray, j) {
      return /*#__PURE__*/_react["default"].createElement("tr", {
        key: j
      }, weekArray.map(function (date, k) {
        return /*#__PURE__*/_react["default"].createElement("td", {
          key: k
        }, date === null ? _p || (_p = /*#__PURE__*/_react["default"].createElement("p", null)) : /*#__PURE__*/_react["default"].createElement("button", {
          className: _constructedForm["default"].dateBtn + " " + theme.BodyCopyBold + " " + (activeDate.getDate() === date.getDate() && activeDate.getFullYear() === date.getFullYear() && activeDate.getMonth() === date.getMonth() ? _constructedForm["default"].isActive : '') + " " + (!_this2.isInPast(today, date) && browseDate.getDate() === date.getDate() && browseDate.getFullYear() === date.getFullYear() && browseDate.getMonth() === date.getMonth() ? _constructedForm["default"].isBrowsed : '') + " " + (_this2.isInPast(today, date) ? _constructedForm["default"].disabledDate : ''),
          onClick: function onClick(e) {
            return clickDateButtonHandler(e, date);
          },
          onFocus: function onFocus(e) {
            return focusDateButtonHandler(e, date);
          }
        }, date.getDate()));
      }));
    })));
  };
  _proto.render = function render() {
    // const { dayMap, month, monthName, year } = this.props.data;
    var _this$props$data2 = this.props.data,
      monthName = _this$props$data2.monthName,
      year = _this$props$data2.year;
    var theme = this.props.theme || {};
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _constructedForm["default"].calendarPanel
    }, /*#__PURE__*/_react["default"].createElement("h3", {
      className: theme.HeaderSm + " " + _constructedForm["default"].calendarTitle
    }, monthName, " ", year), this.renderCalendarPanel());
  };
  return CalendarPanel;
}(_react["default"].Component);
exports["default"] = CalendarPanel;
CalendarPanel.displayName = 'CalendarPanel';
CalendarPanel.defaultProps = {
  data: _constructedForm2["default"].formComponents[5],
  // eslint-disable-line
  theme: {}
};